/// <reference path="../../index.d.ts" />

//@ts-ignore
import * as securitypackage from '../../source/js/securitypackage-api';

const securityApi = {
	package: securitypackage as typeof securitypackageApi,
	directoryService: {
		client: new securitypackage.DirectoryServiceClient() as DirectoryServiceClient,
		fetchTenantByID: (tenantID: number) => {
			return new Promise<Tenant>(resolve => {
				securityApi.directoryService.client.getTenantByID(tenantID, result => {
					resolve(result);
				});
			});
		},
		updateTenant: (tenant: Tenant) => {
			return new Promise<Tenant>(resolve => {
				securityApi.directoryService.client.updateTenant(tenant, result => {
					resolve(result);
				});
			});
		},
	},
	authenticationService: {
		client: new securitypackage.AuthenticationServiceClient() as AuthenticationServiceClient,
		requestPasswordRecovery: (login: string) => {
			return new Promise<SuccessMessage>(resolve => {
				securityApi.authenticationService.client.requestPasswordRecovery(login, result => {
					resolve(result);
				});
			});
		},
		recoverPassword: (code: string, login: string, newPassword: string) => {
			return new Promise<SuccessMessage>(resolve => {
				securityApi.authenticationService.client.recoverPassword(code, login, newPassword, result => {
					resolve(result);
				});
			});
		}
	},
	authorizationService: {
		client: new securitypackage.AuthorizationServiceClient() as AuthorizationServiceClient,
		fetchAccessTokens: (includeRevoked: boolean = false) => {
			return new Promise<Array<OAuthAccessToken>>(resolve => {
				securityApi.authorizationService.client.getAccessTokens(includeRevoked, result => {
					resolve(result);
				});
			});
		},
		generateAccessToken: () => {
			return new Promise<OAuthAccessToken>(resolve => {
				securityApi.authorizationService.client.generateAccessToken(result => {
					resolve(result);
				});
			});
		},
		revokeAccessToken: (tokenValue: string) => {
			return new Promise<boolean>(resolve => {
				securityApi.authorizationService.client.revokeAccessToken(tokenValue, result => {
					resolve(JSON.parse(`${result}`));
				});
			});
		},
	},
	externalSystemService: {
		client: new securitypackage.ExternalSystemServiceClient() as ExternalSystemServiceClient,
		fetchExternalSystemAccountByID: (ID: number) => {
			return new Promise<ExternalSystemAccount>(resolve => {
				securityApi.externalSystemService.client.getExternalSystemAccountByID(ID, result => {
					resolve(result);
				})
			});
		},
		fetchExternalSystemAccounts: () => {
			return new Promise<Array<ExternalSystemAccount>>(resolve => {
				securityApi.externalSystemService.client.getExternalSystemAccounts(result => {
					resolve(result);
				})
			});
		},
		fetchExternalSubsystemInstances: () => {
			return new Promise<Array<SubsystemInstance>>(resolve => {
				securityApi.externalSystemService.client.getExternalSubsystemInstances(result => {	
					resolve(result);
				});
			}); 
		},
		addExternalSystemAccount: (account: ExternalSystemAccount) => {
			return new Promise<ExternalSystemAccount>(resolve => {
				securityApi.externalSystemService.client.addExternalSystemAccount(account, result => {
					resolve(result);
				});
			});
		},
		changeExternalSystemAccount: (account: ExternalSystemAccount) => {
			return new Promise<ExternalSystemAccount>(resolve => {
				securityApi.externalSystemService.client.updateExternalSystemAccount(account, result => {
					resolve(result);
				});
			});
		},
		removeExternalSystemAccount(ID: number) {
			return new Promise<boolean>(resolve => {
				securityApi.externalSystemService.client.removeExternalSystemAccount(ID, result => {
					resolve(JSON.parse(`${result}`));
				});
			});
		}
	},
};

export default securityApi;
